(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-collection-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function mapImg(chero, sel) {
    return Array.prototype.map.call(chero.querySelectorAll(sel), function (e) { return e.getAttribute('data-img'); });
  }
  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }
  function fillChero(scope) {
    (scope || document).querySelectorAll('.studio-chero').forEach(function (chero) {
      if (chero._cheroDone) return;
      chero._cheroDone = true;

      // ---- Desktop: 3 random products from this collection (unchanged) ----
      var pool = shuffle(mapImg(chero, '.studio-chero__pool [data-img]'));
      var cells = chero.querySelectorAll('[data-chero-prod]');
      Array.prototype.forEach.call(cells, function (cell, idx) {
        var url = pool[idx % pool.length];
        if (!url) return;
        var im = document.createElement('img');
        im.src = url; im.loading = 'lazy'; im.alt = '';
        cell.appendChild(im);
      });

      // ---- Mobile: cycle 4 products — 2 women + 2 men — from this collection ----
      var slidesBox = chero.querySelector('[data-chero-slides]');
      if (slidesBox) {
        var women = shuffle(mapImg(chero, '.studio-chero__pool-w [data-img]'));
        var men = shuffle(mapImg(chero, '.studio-chero__pool-m [data-img]'));
        var picks = [women[0], men[0], women[1], men[1]].filter(Boolean);
        // top up to 4 from the general pool if a group is short
        if (picks.length < 4) {
          for (var k = 0; k < pool.length && picks.length < 4; k++) {
            if (picks.indexOf(pool[k]) < 0) picks.push(pool[k]);
          }
        }
        if (picks.length) {
          picks.forEach(function (url, idx) {
            var im = document.createElement('img');
            im.src = url; im.loading = 'lazy'; im.alt = '';
            im.className = 'studio-chero__slide' + (idx === 0 ? ' is-active' : '');
            slidesBox.appendChild(im);
          });
          if (picks.length > 1) {
            var cur = 0;
            var slides = slidesBox.querySelectorAll('.studio-chero__slide');
            setInterval(function () {
              slides[cur].classList.remove('is-active');
              cur = (cur + 1) % slides.length;
              slides[cur].classList.add('is-active');
            }, 3500);
          }
        }
      }
    });
  }
  if (document.readyState !== 'loading') { fillChero(); }
  else { document.addEventListener('DOMContentLoaded', function () { fillChero(); }); }
  document.addEventListener('shopify:section:load', function (e) { fillChero(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-featured-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function shuffle(a){for(var i=a.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1));var t=a[i];a[i]=a[j];a[j]=t;}return a;}
  function distribute() {
    var pool = document.getElementById('shp-pool');
    var a = document.getElementById('shg-a');
    var b = document.getElementById('shg-b');
    if (!pool || !a) return;
    var items = Array.prototype.slice.call(pool.children);
    if (!items.length) return;
    shuffle(items);
    var pick = items.slice(0, 16);
    pick.forEach(function (li, i) {
      li.hidden = false;
      if (i < 8) { a.appendChild(li); }
      else if (b) { b.appendChild(li); }
      else { a.appendChild(li); } // fallback if grid B missing
    });
  }
  if (document.readyState !== 'loading') { distribute(); }
  else { document.addEventListener('DOMContentLoaded', distribute); }
  document.addEventListener('shopify:section:load', distribute);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-header"]) return;
  try {
    
(function () {
  function param(name) { return new URLSearchParams(window.location.search).get(name); }
  function initStudioHeader(scope) {
    (scope || document).querySelectorAll('studio-header').forEach(function (root) {
      // "All" is the default on the /collections/all browse page; nothing is
      // highlighted on the home page or on specific collection pages (those have
      // their own in-collection filter bar).
      var isAll = location.pathname.indexOf('/collections/all') !== -1;
      var audience = isAll ? (param('audience') || 'all') : '';
      var fit = param('fit') || '';

      root.querySelectorAll('.sf-tab').forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.audience === audience);
      });

      var bar = root.querySelector('.sf-filterbar');
      var label = root.querySelector('.sf-filter-label');
      var shown = null;
      root.querySelectorAll('.sf-subs').forEach(function (g) {
        var match = audience !== 'all' && g.dataset.group === audience;
        g.hidden = !match;
        if (match) shown = g;
      });
      if (bar) bar.hidden = !shown;
      if (shown && label) label.textContent = shown.dataset.label || 'FIT:';
      if (shown) {
        shown.querySelectorAll('.sf-sub').forEach(function (s) {
          s.classList.toggle('is-active', (s.dataset.fit || '') === fit);
        });
      }
    });
  }
  function setHeaderHeight(scope) {
    (scope || document).querySelectorAll('studio-header').forEach(function (root) {
      document.documentElement.style.setProperty('--sf-header-h', root.offsetHeight + 'px');
    });
  }
  function boot(scope) {
    initStudioHeader(scope);
    // measure after layout settles (filterbar visibility just changed)
    requestAnimationFrame(function () { setHeaderHeight(scope); });
  }
  if (document.readyState !== 'loading') { boot(); }
  else { document.addEventListener('DOMContentLoaded', function () { boot(); }); }
  window.addEventListener('load', function () { setHeaderHeight(); });
  var _sfRz;
  window.addEventListener('resize', function () { clearTimeout(_sfRz); _sfRz = setTimeout(function () { setHeaderHeight(); }, 150); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-product-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function cyclePhero(scope) {
    (scope || document).querySelectorAll('[data-phero-slides]').forEach(function (box) {
      if (box._pheroCycle) return;
      var slides = box.querySelectorAll('.studio-phero__slide');
      if (slides.length < 2) { box._pheroCycle = true; return; }
      box._pheroCycle = true;
      var cur = 0;
      setInterval(function () {
        slides[cur].classList.remove('is-active');
        cur = (cur + 1) % slides.length;
        slides[cur].classList.add('is-active');
      }, 3500);
    });
  }
  if (document.readyState !== 'loading') { cyclePhero(); }
  else { document.addEventListener('DOMContentLoaded', function () { cyclePhero(); }); }
  document.addEventListener('shopify:section:load', function (e) { cyclePhero(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Only behaviour left in JS is click-to-play for external (YouTube/Vimeo) videos.
  function initTestimonials(scope) {
    (scope || document).querySelectorAll('.testimonials__marquee .tcard__video-trigger').forEach(function (btn) {
      if (btn._tstBound) return;
      btn._tstBound = true;
      btn.addEventListener('click', function () {
        var type = btn.dataset.videoType, id = btn.dataset.videoId, url = btn.dataset.videoUrl, src = '';
        if (type === 'youtube') { src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0'; }
        else if (type === 'vimeo') { src = 'https://player.vimeo.com/video/' + id + '?autoplay=1'; }
        else { src = url; }
        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('title', 'Testimonial video');
        btn.replaceWith(iframe);
      });
    });
  }
  if (document.readyState !== 'loading') { initTestimonials(); }
  else { document.addEventListener('DOMContentLoaded', function () { initTestimonials(); }); }
  document.addEventListener('shopify:section:load', function (e) { initTestimonials(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
